
import React, { useState, useEffect } from 'react';
import SweetAlert from "react-bootstrap-sweetalert";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { makeStyles } from "@material-ui/core/styles";
import { Trans } from 'react-i18next';
const useStyles = makeStyles(styles);

const GerenciaAlertIniciar = () => {

    const classes = useStyles();

    const [alert, setAlert] = useState({
        componente: (null),
        isToInicialize: false,
        idToInicializeSend: 0
    });
    const [confAlert, setConfAlert] = useState({
        statusAlert: 0,
        idToInicializeRecieve: 0
    });
    /*
    statusAlert
    1 - showalert
    2 - hideAlert
    3 - sucess 
    */

    useEffect(() => {

        //console.log(confAlert);

        if (confAlert.statusAlert === 1) {
            showAlertInicialize(confAlert.idToInicializeRecieve);
        }
        else if (confAlert.statusAlert === 2) {
            hideAlertInicialize();
        }
        else if (confAlert.statusAlert === 3) {
            successInicialize();
        }

    }, [confAlert]);

    const confirmInicialize = (id) => {
        setAlert(
            {
                componente: null,
                isToInicialize: true,
                idToInicializeSend: id
            }
        );

    }

    const showAlertInicialize = (id) => {

        setAlert(
            {
                componente: (<SweetAlert
                    warning
                    style={{ display: "block", marginTop: "-200px" }}
                    title={<Trans i18nKey="information_message.inicialize_campaign">
                        Tem certeza que deseja Iniciar essa campanha?
                    </Trans>}
                    onConfirm={() => confirmInicialize(id)}
                    onCancel={() => setConfAlert({ statusAlert: 2 })}
                    confirmBtnCssClass={classes.button + " " + classes.success}
                    cancelBtnCssClass={classes.button + " " + classes.danger}
                    confirmBtnText={<Trans i18nKey="information_message.confirm_inicialize_campaign"> Sim, Iniciar Campanha! </Trans>}
                    cancelBtnText={<Trans i18nKey="button.cancel"> Cancelar </Trans>}
                    showCancel
                >
                    {<Trans i18nKey="information_message.warning_delete_message">
                        Tem certeza que deseja Iniciar essa campanha?
                    </Trans>}
                </SweetAlert>),
                isToInicialize: false

            }
        );
    };

    const successInicialize = () => {

        setAlert(
            {
                componente: (<SweetAlert
                    success
                    style={{ display: "block", marginTop: "-200px" }}
                    title={<Trans i18nKey="information_message.campaign_inicialize"> Inciado! </Trans>}
                    onConfirm={() => setConfAlert({ statusAlert: 2 })}
                    confirmBtnCssClass={classes.button + " " + classes.success}
                >
                    {<Trans i18nKey="information_message.success_inicialize_campaign">
                        A campanha foi iniciada com sucesso.
                    </Trans>}
                </SweetAlert>),
                isToInicialize:false
            }
        );

    };

    const hideAlertInicialize = () => {
        setAlert(
            {
                componente: (null),
                isToInicialize: false,
                idToInicialize: 0
            }
        );
    };

    return [alert, setConfAlert];
};

export { GerenciaAlertIniciar };